/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type header_viewer$ref = any;
type selectedCurrency_viewer$ref = any;
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type UserProjectRoleEnumType = ('collaborator' | 'owner' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type app_viewer$ref: FragmentReference;
export type app_viewer = {|
  +id: string,
  +authentication_info: ?{|
    +user_pool_id: string,
    +client_id: string,
    +cognito_domain_url: string,
  |},
  +business_information: ?{|
    +ams: {|
      +id: string,
      +name: string,
      +legal_name: string,
      +website: string,
      +logo: ?string,
      +emails: ?$ReadOnlyArray<?{|
        +email: string,
        +type: string,
      |}>,
      +phone_numbers: ?$ReadOnlyArray<?{|
        +type: string,
        +phone_number: string,
        +is_toll_free: ?boolean,
      |}>,
      +social_media: ?{|
        +image: ?string,
        +facebook: ?string,
        +twitter: ?string,
        +instagram: ?string,
        +youtube: ?string,
      |},
      +opening_hours: ?string,
      +address: {|
        +id: string,
        +name: string,
        +company: ?string,
        +line_1: string,
        +line_2: ?string,
        +city: string,
        +postal_code: string,
        +subdivision_code: string,
        +subdivision_name: ?string,
        +country_code: string,
        +country_name: ?string,
      |},
      +commercial_details: {|
        +financial_institution: {|
          +id: string,
          +name: string,
          +company: ?string,
          +line_1: string,
          +line_2: ?string,
          +city: string,
          +postal_code: string,
          +subdivision_code: string,
          +subdivision_name: ?string,
          +country_code: string,
          +country_name: ?string,
        |},
        +bank_accounts: ?$ReadOnlyArray<?{|
          +currency: ?Currency,
          +swift_code: string,
          +branch_id: string,
          +account_number: string,
        |}>,
        +gst_number: ?string,
        +pst_number: ?string,
      |},
    |},
  |},
  +cart: ?{|
    +id: string,
    +license_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +amount: ?number,
      +discount_amount: ?number,
      +track: ?{|
        +id: string,
        +internal_id: ?number,
        +title: ?string,
        +added_to_cart: ?boolean,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +artist: ?{|
          +id: string,
          +name: ?string,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
        |},
        +terms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +is_highlighted: ?boolean,
              +name: ?string,
              +parent_id: ?string,
              +taxonomy: ?{|
                +id: string,
                +internal_id: ?number,
                +name: ?string,
              |},
            |},
          |}>,
        |},
      |},
      +license: ?{|
        +id: string,
        +usages: ?$ReadOnlyArray<?{|
          +id: string,
          +license_id: ?number,
          +air_date: ?any,
          +components: ?$ReadOnlyArray<?{|
            +id: string,
            +component_id: ?number,
            +name: ?string,
            +type: ?string,
          |}>,
        |}>,
      |},
    |}>,
    +total: ?number,
  |},
  +profile: ?{|
    +id: string,
    +user_id: string,
    +email: ?string,
    +external_provider: ?string,
    +first_name: ?string,
    +is_new_user: boolean,
    +ga_account_goal_sent: boolean,
    +last_name: ?string,
    +picture: ?string,
    +company_name: ?string,
    +company_size: ?{|
      +name: ?string,
    |},
    +industry: ?{|
      +name: ?string,
    |},
    +job_type: ?{|
      +name: ?string,
    |},
  |},
  +latest_exchange_rates: ?$ReadOnlyArray<?{|
    +id: string,
    +from_currency: string,
    +to_currency: string,
    +rate: number,
    +rate_date: any,
  |}>,
  +license_components: ?{|
    +media: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
    +spot_counts: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
    +terms: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
    +broadcast_territories: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
          +is_region: ?boolean,
        |},
      |}>,
    |},
    +producer_locations: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
          +is_user_location: ?boolean,
        |},
      |}>,
    |},
    +audience_sizes: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
    +production_budgets: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
    +episode_budgets: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +internal_id: ?number,
          +display_order: ?number,
          +name: string,
        |},
      |}>,
    |},
  |},
  +projects: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +is_public: ?boolean,
        +name: string,
        +notes: ?string,
        +tracks: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +id: string,
          |}>,
        |},
        +owner: ?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
        |},
        +users: ?$ReadOnlyArray<?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
          +role: UserProjectRoleEnumType,
        |}>,
        +license_params: ?$ReadOnlyArray<?{|
          +spot_count: ?number,
          +term: ?number,
          +medium: number,
          +contextual_param: ?$ReadOnlyArray<?number>,
          +contextual_param_type: string,
        |}>,
      |},
    |}>,
  |},
  +taxonomies: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +internal_id: ?number,
        +name: ?string,
        +terms: ?$ReadOnlyArray<?{|
          +id: string,
          +internal_id: ?number,
          +parent_id: ?string,
          +name: ?string,
          +children: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +internal_id: ?number,
                +parent_id: ?string,
                +name: ?string,
              |},
            |}>,
          |},
        |}>,
      |},
    |}>,
  |},
  +tempos: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +value: ?number,
      |},
    |}>,
  |},
  +$fragmentRefs: (selectedCurrency_viewer$ref & header_viewer$ref),
  +$refType: app_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100,
    "type": "Int"
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "display_order",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = [
  v1,
  v2,
  v3
],
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 300,
    "type": "Int"
  }
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v9 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  },
  v6,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  },
  v3,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_name",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_name",
    "args": null,
    "storageKey": null
  }
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v6,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    v8,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "parent_id",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "user_id",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
},
v16 = [
  v3
],
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "app_viewer",
  "type": "Viewer",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projects"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "license_components",
      "storageKey": null,
      "args": null,
      "concreteType": "LicenseComponents",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "media",
          "storageKey": "media(first:100)",
          "args": v0,
          "concreteType": "MediumConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MediumEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Medium",
                  "plural": false,
                  "selections": v4
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "spot_counts",
          "storageKey": "spot_counts(first:100)",
          "args": v0,
          "concreteType": "SpotCountConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SpotCountEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SpotCount",
                  "plural": false,
                  "selections": v4
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "terms",
          "storageKey": "terms(first:100)",
          "args": v0,
          "concreteType": "TermConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "TermEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Term",
                  "plural": false,
                  "selections": v4
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "broadcast_territories",
          "storageKey": "broadcast_territories(first:300)",
          "args": v5,
          "concreteType": "BroadcastTerritoryConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "BroadcastTerritoryEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "BroadcastTerritory",
                  "plural": false,
                  "selections": [
                    v1,
                    v2,
                    v3,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "is_region",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "producer_locations",
          "storageKey": "producer_locations(first:300)",
          "args": v5,
          "concreteType": "ProducerLocationConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ProducerLocationEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProducerLocation",
                  "plural": false,
                  "selections": [
                    v1,
                    v2,
                    v3,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "is_user_location",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "audience_sizes",
          "storageKey": "audience_sizes(first:100)",
          "args": v0,
          "concreteType": "AudienceSizeConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "AudienceSizeEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "AudienceSize",
                  "plural": false,
                  "selections": v4
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "production_budgets",
          "storageKey": "production_budgets(first:100)",
          "args": v0,
          "concreteType": "ProductionBudgetConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ProductionBudgetEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProductionBudget",
                  "plural": false,
                  "selections": v4
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "episode_budgets",
          "storageKey": "episode_budgets(first:100)",
          "args": v0,
          "concreteType": "EpisodeBudgetConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EpisodeBudgetEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "EpisodeBudget",
                  "plural": false,
                  "selections": v4
                }
              ]
            }
          ]
        }
      ]
    },
    v6,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "business_information",
      "storageKey": null,
      "args": null,
      "concreteType": "BusinessInformationDirectory",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "ams",
          "storageKey": null,
          "args": null,
          "concreteType": "BusinessInformation",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "emails",
              "storageKey": null,
              "args": null,
              "concreteType": "BusinessEmail",
              "plural": true,
              "selections": [
                v7,
                v8
              ]
            },
            v6,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "legal_name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "website",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "logo",
              "args": null,
              "storageKey": null
            },
            v3,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "phone_numbers",
              "storageKey": null,
              "args": null,
              "concreteType": "BusinessPhoneNumber",
              "plural": true,
              "selections": [
                v8,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone_number",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_toll_free",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "social_media",
              "storageKey": null,
              "args": null,
              "concreteType": "BusinessSocialMedia",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "image",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "facebook",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "twitter",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "instagram",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "youtube",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "opening_hours",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "address",
              "storageKey": null,
              "args": null,
              "concreteType": "Address",
              "plural": false,
              "selections": v9
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "commercial_details",
              "storageKey": null,
              "args": null,
              "concreteType": "BusinessCommercialDetails",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "financial_institution",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Address",
                  "plural": false,
                  "selections": v9
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "bank_accounts",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "BusinessBankAccount",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "currency",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "swift_code",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "branch_id",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "account_number",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "gst_number",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "pst_number",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cart",
      "storageKey": null,
      "args": null,
      "concreteType": "Cart",
      "plural": false,
      "selections": [
        v6,
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "license_line_items",
          "storageKey": null,
          "args": null,
          "concreteType": "LicenseLineItem",
          "plural": true,
          "selections": [
            v6,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "discount_amount",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "track",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackSearchResult",
              "plural": false,
              "selections": [
                v6,
                v1,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "added_to_cart",
                  "args": null,
                  "storageKey": null
                },
                v10,
                v11,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "artist",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Artist",
                  "plural": false,
                  "selections": [
                    v6,
                    v3,
                    v10,
                    v11
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "terms",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "TaxonomyTermEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "TaxonomyTerm",
                          "plural": false,
                          "selections": [
                            v6,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "is_highlighted",
                              "args": null,
                              "storageKey": null
                            },
                            v3,
                            v12,
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "taxonomy",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Taxonomy",
                              "plural": false,
                              "selections": [
                                v6,
                                v1,
                                v3
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "license",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicense",
              "plural": false,
              "selections": [
                v6,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "usages",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "StandardLicenseUsage",
                  "plural": true,
                  "selections": [
                    v6,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "license_id",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "air_date",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "components",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "StandardLicenseUsageComponent",
                      "plural": true,
                      "selections": [
                        v6,
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "component_id",
                          "args": null,
                          "storageKey": null
                        },
                        v3,
                        v8
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "total",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "ga_account_goal_sent",
          "args": null,
          "storageKey": null
        },
        v6,
        v7,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "external_provider",
          "args": null,
          "storageKey": null
        },
        v13,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "is_new_user",
          "args": null,
          "storageKey": null
        },
        v14,
        v15,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "picture",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company_name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "company_size",
          "storageKey": null,
          "args": null,
          "concreteType": "CompanySize",
          "plural": false,
          "selections": v16
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "industry",
          "storageKey": null,
          "args": null,
          "concreteType": "Industry",
          "plural": false,
          "selections": v16
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "job_type",
          "storageKey": null,
          "args": null,
          "concreteType": "JobType",
          "plural": false,
          "selections": v16
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "latest_exchange_rates",
      "storageKey": null,
      "args": null,
      "concreteType": "ExchangeRate",
      "plural": true,
      "selections": [
        v6,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "from_currency",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "to_currency",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "rate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "rate_date",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "authentication_info",
      "storageKey": null,
      "args": null,
      "concreteType": "AuthenticationInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "user_pool_id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "client_id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cognito_domain_url",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "projects",
      "name": "__list_projects_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ProjectEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Project",
              "plural": false,
              "selections": [
                v6,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_public",
                  "args": null,
                  "storageKey": null
                },
                v3,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "notes",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": "tracks",
                  "name": "__project_tracks_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProjectTrackConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ProjectTrackEdge",
                      "plural": true,
                      "selections": [
                        v6,
                        v17,
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "TrackSearchResult",
                          "plural": false,
                          "selections": [
                            v18
                          ]
                        }
                      ]
                    },
                    v19
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "owner",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProjectUser",
                  "plural": false,
                  "selections": [
                    v6,
                    v13,
                    v15,
                    v14
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "users",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProjectUser",
                  "plural": true,
                  "selections": [
                    v6,
                    v13,
                    v15,
                    v14,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "role",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "license_params",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LicenseUsageParams",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "spot_count",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "term",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "medium",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "contextual_param",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "contextual_param_type",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                v18
              ]
            },
            v17
          ]
        },
        v19
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "taxonomies",
      "storageKey": "taxonomies(first:10000000)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000000,
          "type": "Int"
        }
      ],
      "concreteType": "TaxonomyConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxonomyEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Taxonomy",
              "plural": false,
              "selections": [
                v6,
                v1,
                v3,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "terms",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTerm",
                  "plural": true,
                  "selections": [
                    v6,
                    v1,
                    v12,
                    v3,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "children",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "TaxonomyTermConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "TaxonomyTermEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "TaxonomyTerm",
                              "plural": false,
                              "selections": [
                                v6,
                                v1,
                                v12,
                                v3
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tempos",
      "storageKey": null,
      "args": null,
      "concreteType": "TempoConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TempoEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Tempo",
              "plural": false,
              "selections": [
                v6,
                v3,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "value",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "selectedCurrency_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "header_viewer",
      "args": null
    }
  ]
};
})();
(node/*: any*/).hash = '45fedc39dabf74af04411ef480a81940';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/app_viewer.graphql.js